<template>
	<div>
		<div v-if="step == 'criate'" class="row">
			<div class="col-sm-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">Visualizar</h3>
						<div class="box-tools pull-right">
							<button
								class="btn-sm btn btn-success"
								@click="step = 'final'"
							>
								Avançar
								<i class="fa fa-arrow-right"></i>
							</button>
						</div>
					</div>
					<div class="box-body cntModal">
						<md-form-read
							:chForm="chForm"
							@openInput="opInp"
						></md-form-read>
					</div>
				</div>
			</div>
			<!-- Configuracoes -->
			<fSettings />
			<!-- Campos -->
			<sInputs />
			<!-- Tabs -->
			<mAbas />
			<!-- Dicionário -->
			<mDicionario />
		</div>
		<end-form v-else :data="chForm" @backStep="stepFxOut" />
		<md-options
			:options="options"
			:typesl="input.type"
			@confirm="outFnOptions"
		/>

		<!-- <pre>{{chForm}}</pre> -->
	</div>
</template>
<script>
	import WBS from 'js/http';
	import clone from 'js/clone';
	import parseId from 'js/parseId';
	import md5 from 'js/md5';

	import toastr from 'toastr';

	import MdFormRead from './components/mdFormLoad.vue';
	import MdOptions from './components/mdOptions.vue';
	import EndForm from './components/end-form.vue';

	import fSettings from './components/settings.vue';
	import sInputs from './components/settings-inputs.vue';
	import mAbas from './components/tabs.vue';
	import mDicionario from './components/dicionario.vue';

	//Resets
	import RsModalReadForm from './resets/modal-form-load.js';
	import rsInputs from './resets/input-smart-form.js';

	export default {
		name: 'SmsCreatorForm',
		data() {
			return {
				chForm: clone(RsModalReadForm),
				input: clone(rsInputs),
				open: false,
				slid: null,
				step: 'criate',
				options: {
					type: 'options',
					inTable: '',
					options: [],
					aling: '',
				},
				inpNewAba: '',
				abasl: '',
				listAllInputs: false,
				sTables: [],
			};
		},
		components: {
			MdFormRead,
			MdOptions,
			EndForm,
			fSettings,
			sInputs,
			mAbas,
			mDicionario,
		},
		computed: {
			optionsValue() {
				//console.log(this.input.options.type)
				if (this.input.options.type == 'table-db') {
					return 'Tabela : ' + this.input.options.inTable;
				} else {
					if (typeof this.input.options.options == 'object')
						return this.input.options.options.length + ' opção(s)';
				}
				//console.log(this.input.options)
			},
			getData() {
				let resp = [];
				this.chForm.inputs.forEach((item) => {
					if (item.type != 'msg') {
						if (typeof item.value == 'object') {
							resp.push({
								input: item.id,
								value: `${item.value.length} Linha(s)`,
							});
						} else {
							let val = item.value;
							if (item.value == '') val = 'Não definido';
							resp.push({ input: item.id, value: val });
						}
					}
				});
				return resp;
			},
		},
		methods: {
			//dicionario

			stepFxOut() {
				this.step = 'criate';
			},

			// Abas ===============
			getNameAba(id) {
				let name = 'Oculto';
				this.chForm.abas.list.forEach((item) => {
					if (item.id == id) name = item.titulo;
				});
				return name;
			},
			addAba() {
				if (this.inpNewAba != '') {
					this.chForm.abas.list.push({
						id: md5.get(this.inpNewAba + new Date()),
						titulo: this.inpNewAba,
					});
					if (this.chForm.abas.active == '') {
						this.chForm.abas.active = this.chForm.abas.list[0].id;
					}
					this.inpNewAba = '';
				}
			},
			//=====================
			resetForm() {
				swal({
					title: 'Atenção',
					text: 'Você está prestes a apagar tudo que fez até agora. \n Tem certeza disso?',
					confirmButtonClass: 'btn-sm btn-danger',
					cancelButtonClass: 'btn-default btn-sm',
				}).then(() => {
					this.chForm = clone(RsModalReadForm);
					this.input = clone(rsInputs);
					this.slid = null;
					this.open = false;
					toastr.success('Formulário resetado');
				});
			},
			getValue(val) {
				if (typeof val == 'object') {
					return val.length + ' Linhas';
				} else {
					return val;
				}
				//console.log(typeof(val), val)
			},
			addInput() {
				if (this.input.id != '') {
					this.chForm.inputs.push(this.input);
					this.input = clone(rsInputs);
					this.$children[2].oldId = '';
				}
			},
			opInp(data) {
				this.slid = data.id;
				this.$children[2].oldId = data.data.id;
				this.input = data.data;
				this.listAllInputs = false;
				this.open = true;
			},
			updateObj() {
				this.$set(this.chForm.inputs, this.slid, this.input);
				this.input = clone(rsInputs);
				this.$children[2].oldId = '';
				this.slid = null;
				this.open = false;
			},
			setId() {
				this.input.id = parseId(this.input.label);
			},
			openMdOptions(data) {
				this.options = clone(this.input.options);
				jQuery('#mdOptions').modal('show');
			},
			outFnOptions(data) {
				this.$set(this.input, 'options', data);
				if (this.slid !== null) {
					this.$set(this.chForm.inputs, this.slid, this.input);
				}
				jQuery('#mdOptions').modal('hide');
			},
			isOptCamp(type) {
				if (
					type == 'select' ||
					type == 'radio' ||
					type == 'checkbox' ||
					type == 'table'
				)
					return true;
				else false;
			},
			deleteCamp() {
				this.slid = null;
				this.open = false;
				this.$children[2].oldId = '';
				this.input = clone(rsInputs);
				this.chForm.inputs.splice(this.slid, 1);
			},
		},
		mounted() {
			this.$emit('setHeader', [
				'Form Manegar',
				'CRIAR/EDITAR FORMULÁRIO ADICIONAL PARA A TAREFA!',
			]);

			if (this.$route.params.cod != undefined) {
				const sData = {
					cod: this.$route.params.cod,
				};
				WBS.send('private-read-singleForm', sData, (resp) => {
					if (resp.status == 'success') {
						this.sTables = resp.data.sTables;
						this.$set(this, 'chForm', resp.data.sForm);
					}
				});
			}
		},
	};
</script>
<style scoped>
	.cntModal {
		background: rgba(0, 0, 0, 0.3);
	}

	.form-control {
		padding: 5.5px 4px;
		height: auto;
	}

	.val1 {
		margin-top: -8px;
		margin-left: -8px;
		display: block;
	}
	.val2 {
		margin-top: -6px;
		margin-left: -8px;
		margin-bottom: -8px;
		display: block;
	}
	.list-group-item {
		cursor: pointer;
	}
	.list-group {
		margin: 0px;
	}
	.margin-none {
		margin-top: 0;
		margin-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/index.vue